import { render, staticRenderFns } from "./luckyCharm.vue?vue&type=template&id=991396f0&scoped=true&"
import script from "./luckyCharm.vue?vue&type=script&lang=js&"
export * from "./luckyCharm.vue?vue&type=script&lang=js&"
import style0 from "./luckyCharm.vue?vue&type=style&index=0&id=991396f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991396f0",
  null
  
)

component.options.__file = "luckyCharm.vue"
export default component.exports